import { Component } from '@angular/core';
import { AuthSession } from '@navify-platform/auth';
import { NavifyService } from 'src/app/auth/services/navify.service';
import { LabelService } from 'src/app/shared/services/label.service';

@Component({
  standalone: false,
  selector: 'app-app-lobby',
  templateUrl: './app-lobby.component.html',
  styleUrls: ['./app-lobby.component.scss']
})
export class AppLobbyComponent {
  i18n = this.labelService.labels;
  sessionInfo!: AuthSession;
  links: string[] = [
  ]

  constructor(
    private readonly nanvifyService: NavifyService,
    private readonly labelService: LabelService
  ) { }

  ngOnInit() {
    this.sessionInfo = this.nanvifyService.sessionInfo
  }

}
